<template>
  <div>
    <ViewTemplateConfiguration :templateList="templateList" :actions="actions">
      <div slot="content-buttons">
        <Button _key="btnOriginCustomerCreate" title="Origem" classIcon="fas fa-plus-circle" type="primary" size="small"
          :clicked="create" />
      </div>
    </ViewTemplateConfiguration>
    <Modal title="Origem" :width="500" :height="250" v-show="showModal('originCustomerCreateUpdate')">
      <OriginCustomerCreateUpdate />
    </Modal>
  </div>
</template>

<script>

import ViewTemplateConfiguration from "@nixweb/nixloc-ui/src/component/template/ViewTemplateConfiguration";
import OriginCustomerCreateUpdate from '../../../components/modules/crm/category-customer/OriginCustomerCreateUpdate.vue'

import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "OriginCustomerView",
  components: {
    ViewTemplateConfiguration,
    Button,
    Modal,
    OriginCustomerCreateUpdate
  },
  data() {
    return {
      templateList: {
        urlGetApi: "/api/v1/crm/origin-customer/get-all",
        urlDeleteAllApi: "/api/v1/crm/origin-customer/delete",
        headerTable: [
          {
            field: "name",
            title: "Nome",
            type: "link",
            iconSearch: true,
            eventName: "originCustomerUpdate",
          },
        ],
      },
      actions: [
        { type: "delete", title: "Remover", description: "Remover", url: "/api/v1/crm/origin-customer/delete", method: "delete", },
      ],
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal", "removeLoading"]),
    create() {
      this.openModal("originCustomerCreateUpdate");
      this.addEvent({ name: "originCustomerCreate" });
      this.removeLoading(["btnOriginCustomerCreate"]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "originCustomerUpdate")
          this.openModal("originCustomerCreateUpdate");
      },
      deep: true,
    },
  },
};
</script>
